// frontend/src/askos/liveSessions/LiveQAWidget.js
//
// Student-side Q&A: post a question, see own questions + faculty answers.
// Polling (no WebSocket precedent in this app).
import React, { useCallback, useEffect, useState } from 'react';
import { askLiveSessionQuestion, listMyQuestions } from '../../api/liveSessionsApi';

const LiveQAWidget = ({ slug, sessionId }) => {
    const [questions, setQuestions] = useState([]);
    const [draft, setDraft] = useState('');
    const [sending, setSending] = useState(false);

    const load = useCallback(() => {
        listMyQuestions(slug, sessionId).then(setQuestions).catch(() => {});
    }, [slug, sessionId]);

    useEffect(() => {
        load();
        const interval = setInterval(load, 8000);
        return () => clearInterval(interval);
    }, [load]);

    const submit = async (e) => {
        e.preventDefault();
        if (!draft.trim()) return;
        setSending(true);
        try {
            await askLiveSessionQuestion(slug, sessionId, draft.trim());
            setDraft('');
            load();
        } finally {
            setSending(false);
        }
    };

    return (
        <div style={{ background: '#fff', borderRadius: 12, padding: 16 }}>
            <h6 className="fw-bold">Ask a Question</h6>
            <form onSubmit={submit} className="d-flex gap-2 mb-3">
                <input
                    type="text"
                    value={draft}
                    onChange={e => setDraft(e.target.value)}
                    placeholder="Type your question for the faculty..."
                    style={{ flex: 1, padding: '8px 12px', borderRadius: 8, border: '1px solid #ddd' }}
                />
                <button type="submit" disabled={sending} className="primary-btn">Send</button>
            </form>

            <div style={{ maxHeight: 260, overflowY: 'auto' }}>
                {questions.length === 0 && <p className="empty-note">No questions asked yet.</p>}
                {questions.map(q => (
                    <div key={q.id} style={{ marginBottom: 10, paddingBottom: 10, borderBottom: '1px solid #eee' }}>
                        <strong style={{ fontSize: 13 }}>{q.question_text}</strong>
                        <div style={{ fontSize: 12, color: q.status === 'answered' ? '#1a7f37' : '#8a6d3b' }}>
                            {q.status === 'answered' ? `Answered: ${q.answer_text}` : 'Pending faculty answer'}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default LiveQAWidget;
